import { GatewayDiagram } from "@arcadeai/design-system/components/ui/templates/gateway-diagram";
import {
  type McpClientId as BrandClientId,
  MCP_CLIENT_METADATA,
} from "@arcadeai/design-system/metadata/mcp-clients";
import type { McpClientId } from "@arcadeai/ui-kit/mcp-gateway-connect";
import type { JSX } from "react";

function resolveClientIds(
  clientId: McpClientId | undefined
): readonly BrandClientId[] {
  // A selected client narrows the left side to just that logo. Anything
  // without brand metadata falls back to the generic MCP logo rather than
  // the full client catalogue, so the diagram still anchors on a single
  // tile that matches "you're connecting via MCP".
  if (clientId && clientId in MCP_CLIENT_METADATA) {
    // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
    return [clientId as BrandClientId];
  }
  return ["mcp_url"];
}

type OnboardingConnectDiagramProps = {
  /** The client the user is connecting, when one has been selected. */
  clientId?: McpClientId;
  /** Toolkit ids exposed by the gateway (e.g. `Gmail`, `Slack`). */
  services: string[];
  className?: string;
};

/**
 * Connect-step hero: the user's MCP client(s) fan into the Arcade hub,
 * which fans out to the toolkits their gateway exposes. Thin wrapper over
 * the design-system `GatewayDiagram` that feeds it the real gateway data.
 */
export function OnboardingConnectDiagram({
  clientId,
  services,
  className,
}: OnboardingConnectDiagramProps): JSX.Element {
  return (
    <GatewayDiagram
      animate="left"
      animation="dot"
      className={className}
      mcpClientIds={resolveClientIds(clientId)}
      mcpServerIds={services}
    />
  );
}
